import Fuse, { IFuseOptions } from 'fuse.js';
import type { Product } from '../types';

export const SEARCH_FUSE_OPTIONS: IFuseOptions<Product> = {
  keys: [
    { name: 'name', weight: 0.6 },
    { name: 'tags.category_tags', weight: 0.2 },
    { name: 'tags.purpose_tags', weight: 0.1 },
    { name: 'tags.generic_tags', weight: 0.05 },
    { name: 'benefits', weight: 0.05 },
  ],
  includeScore: true,
  threshold: 0.4,
  ignoreLocation: true,
};

/**
 * Searches products using fuzzy matching while prioritizing direct title matches.
 */
export const searchProducts = (products: Product[], query: string): Product[] => {
  const q = query.trim().toLowerCase();
  if (!q || products.length === 0) return [];

  const fuse = new Fuse(products, SEARCH_FUSE_OPTIONS);
  const searchResults = fuse.search(q);

  searchResults.sort((a, b) => {
    const aTitle = (a.item.name || '').toLowerCase();
    const bTitle = (b.item.name || '').toLowerCase();

    const aExactTitle = aTitle === q;
    const bExactTitle = bTitle === q;
    if (aExactTitle && !bExactTitle) return -1;
    if (!aExactTitle && bExactTitle) return 1;

    const aInTitle = aTitle.includes(q);
    const bInTitle = bTitle.includes(q);
    if (aInTitle && !bInTitle) return -1;
    if (!aInTitle && bInTitle) return 1;

    return (a.score ?? 1) - (b.score ?? 1);
  });

  return searchResults.map((res) => res.item);
};
